import { useFormatTemplateStore } from "@/state/formatTemplateStore";

import ColorHeader from "@/components/ui/ColorHeader";
import DynamicColorPickerForm from "@/components/ui/DynamicColorPickerForm";
import { ColorEntry } from "@/utils/formatTemplate/formatTemplate";
import Ring from "@/components/ui/Ring";

export default function ColorsStep() {
  const colorsSection = useFormatTemplateStore((state) => state.colorsSection);
  const { updateColorsSection } = useFormatTemplateStore();
  return (
    <Ring className={"p-4 mt-10 flex flex-col gap-8"}>
      <p>This is the base font specifications we will use for chart and table creation.</p>
      <div>
        <ColorHeader
          name="Charts"
          textColor="Text Color (rgb)"
          fillColor="Fill Color (rgb)"
          text="When the fill color is used, this is the corresponding color of text that is written over where the fill color is used (such as labels on a bar)."
        />

        <DynamicColorPickerForm
          value={colorsSection.chartColors}
          onChange={(value: ColorEntry[]) => updateColorsSection("chartColors", value)}
        />

        <ColorHeader
          name="Tables"
          textColor="Text Color (rgb)"
          fillColor="Fill Color (rgb)"
          text="When the fill color is used, this is the corresponding color of text that is written over where the fill color is used (such as labels on a bar)."
        />

        <DynamicColorPickerForm
          value={colorsSection.tableColors}
          onChange={(value: ColorEntry[]) => updateColorsSection("tableColors", value)}
        />
      </div>
    </Ring>
  );
}
